export const shouldShowExperimentPromotion = (
  experimentName: string,
  getExperiment: (experimentName: string) => {
    get: (param: string, defaultValue: any) => any;
  },
) => {
  return getExperiment(experimentName).get("promotion", false);
};

const resolveStatsigValue = (
  value: string,
  experimentName: string,
  getExperiment: (experimentName: string) => {
    get: (param: string, defaultValue: any) => any;
  },
): string => {
  if (typeof value === "string" && value.startsWith("statsig_")) {
    const parameterName = value.substring(8);

    return getExperiment(experimentName).get(parameterName, value) || value;
  }
  return value;
};

const processStatsigFields = (
  data: any,
  experimentName: string,
  getExperiment: (experimentName: string) => {
    get: (param: string, defaultValue: any) => any;
  },
): any => {
  if (!data || typeof data !== "object") return data;

  const copyAndImageFields = [
    "title",
    "subtitle",
    "image",
    "buttonCopy",
    "content",
    "topBannerCopy",
    "imageUrl",
    "headerCopy",
    "subTextCopy",
    "buttonCTA",
    "backgroundImage",
  ];

  const processedData = { ...data };

  copyAndImageFields.forEach((field) => {
    if (processedData[field] && typeof processedData[field] === "string") {
      processedData[field] = resolveStatsigValue(
        processedData[field],
        experimentName,
        getExperiment,
      );
    }
  });

  return processedData;
};

export const filterPromotionsByExperiment = (
  data: any,
  shouldShowExperimentPromotion: (experimentName: string) => boolean,
  getExperiment?: (experimentName: string) => {
    get: (param: string, defaultValue: any) => any;
  },
): any => {
  if (!data) return data;

  if (Array.isArray(data)) {
    const filteredData = data
      .map((item) => {
        if (!item?.experimentName) return item;

        const shouldShowPromotion = shouldShowExperimentPromotion(
          item.experimentName,
        );
        if (shouldShowPromotion && getExperiment) {
          const processedData = processStatsigFields(
            item,
            item.experimentName,
            getExperiment,
          );
          return processedData;
        }
        return shouldShowPromotion ? item : null;
      })
      .filter((item) => item !== null);
    return filteredData;
  }

  if (typeof data === "object" && data !== null) {
    if (data?.experimentName) {
      const isInExperiment = shouldShowExperimentPromotion(data.experimentName);
      if (isInExperiment && getExperiment) {
        return processStatsigFields(data, data.experimentName, getExperiment);
      }
      return isInExperiment ? data : null;
    }
  }

  return data;
};

export const checkForPromotionExperiments = (
  promotionsData: any,
  shouldShowExperimentPromotion: (experimentName: string) => boolean,
  getExperiment?: (experimentName: string) => {
    get: (param: string, defaultValue: any) => any;
  },
): any => {
  if (!promotionsData) return promotionsData;

  return {
    ...promotionsData,
    activeSiteSideRailAd: filterPromotionsByExperiment(
      promotionsData.activeSiteSideRailAd,
      shouldShowExperimentPromotion,
      getExperiment,
    ),
    activeSiteTopBanner: filterPromotionsByExperiment(
      promotionsData.activeSiteTopBanner,
      shouldShowExperimentPromotion,
      getExperiment,
    ),
    activeSitePaywallPromo: filterPromotionsByExperiment(
      promotionsData.activeSitePaywallPromo,
      shouldShowExperimentPromotion,
      getExperiment,
    ),
    activeUpgradePagePromo: filterPromotionsByExperiment(
      promotionsData.activeUpgradePagePromo,
      shouldShowExperimentPromotion,
      getExperiment,
    ),
    activeClipPagePromos: filterPromotionsByExperiment(
      promotionsData.activeClipPagePromos,
      shouldShowExperimentPromotion,
      getExperiment,
    ),
    activeSiteVideoPlayerPromos: filterPromotionsByExperiment(
      promotionsData.activeSiteVideoPlayerPromos,
      shouldShowExperimentPromotion,
      getExperiment,
    ),
    activeSiteFirstLandModal: filterPromotionsByExperiment(
      promotionsData.activeSiteFirstLandModal,
      shouldShowExperimentPromotion,
      getExperiment,
    ),
    activeCarouselPromos: filterPromotionsByExperiment(
      promotionsData.activeCarouselPromos,
      shouldShowExperimentPromotion,
      getExperiment,
    ),
    activeMobileCarouselPromos: filterPromotionsByExperiment(
      promotionsData.activeMobileCarouselPromos,
      shouldShowExperimentPromotion,
      getExperiment,
    ),
    activeMobileTakeoverPromos: filterPromotionsByExperiment(
      promotionsData.activeMobileTakeoverPromos,
      shouldShowExperimentPromotion,
      getExperiment,
    ),
  };
};
